import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum FixedRouteForDisplayPermissionSet {
  View = 'fixed_route_for_display_view',
  Write = 'fixed_route_for_display_write',
}

export const fixedRouteForDisplayPermissionSetGrouping: IPermissionSetGrouping<FixedRouteForDisplayPermissionSet> = {
  key: PermissionSetGroupingKey.FixedRouteForDisplay,
  active: {
    [FixedRouteForDisplayPermissionSet.View]: [
      PermissionType.GET_FIXED_ROUTE_FOR_DISPLAY,
      PermissionType.LIST_FIXED_ROUTE,
    ],
    [FixedRouteForDisplayPermissionSet.Write]: [
      PermissionType.POST_FIXED_ROUTE_FOR_DISPLAY,
      PermissionType.PATCH_FIXED_ROUTE_FOR_DISPLAY,
    ],
  },
  unAssignablePermissionSets: [],
}
